<template>
  <div class="routines-switch">
    <div
      v-if="hasBothSlots"
      class="switch-wrapper"
    >
      <label class="switch">
        <input
          ref="switchCheckbox"
          v-model="displaySecond"
          type="checkbox"
          name="routines-mode"
          @focus="focus"
        >
        <span :class="['slider round', {'slider--focus': checkboxFocus}]" />
        <span class="is-sr-only">{{ current }}</span>
      </label>
      <div class="switch-wrapper__description">
        <div :class="['label', { 'label--active': !displaySecond }]">
          <img
            :alt="switchFirstLabel"
            class="icon"
            :src="displaySecond ? switchFirstIcon:switchFirstIconActive"
          >
          {{ switchFirstLabel }}
        </div>
        <div :class="['label', { 'label--active': displaySecond }]">
          <img
            :alt="switchSecondLabel"
            class="icon"
            :src="displaySecond ? switchSecondIconActive:switchSecondIcon"
          >
          {{ switchSecondLabel }}
        </div>
      </div>
    </div>

    <div
      v-if="!displaySecond"
      key="default"
    >
      <slot />
    </div>

    <div
      v-if="displaySecond"
      key="second"
    >
      <slot name="second" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RoutinesSwitch',
    props: {
      switchFirstLabel: { type: String, required: false, default: 'Daytime' } ,
      switchSecondLabel: { type: String, required: false, default: 'Nighttime' },
      switchFirstIcon: { type: String, required: false, default: '' },
      switchFirstIconActive: { type: String, required: false, default: '' },
      switchSecondIcon: { type: String, required: false, default: '' },
      switchSecondIconActive: { type: String, required: false, default: '' }
    },
    data() {
      return {
        displaySecond: false,
        checkboxFocus: false
      };
    },
    computed: {
      current() {
        return this.displaySecond ? this.switchSecondLabel : this.switchFirstLabel;
      },
      hasBothSlots() {
        return this.$slots.default && this.$slots.second;
      }
    },
    mounted() {
      this.checkForSingleSlot();
    },
    methods: {
      focus(e) {
        this.checkboxFocus = (e.target === this.$refs.switchCheckbox);
      },
      checkForSingleSlot() {
        if (!this.$slots.default && this.$slots.second) {
          this.displaySecond = true;
        }
      }
    }
  };
</script>
